import { Select } from "antd";

const filterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const ClientFilter = ({ handleSelectClient, clientOptions }) => {
  return (
    <Select
      className="ml-2 w-48"
      allowClear
      virtual={false}
      showSearch
      placeholder="Select or search client"
      optionFilterProp="children"
      onChange={handleSelectClient}
      filterOption={filterOption}
      options={clientOptions}
    />
  );
};

export default ClientFilter;
